
    // this file was auto generated by python script
    import AlertOctagon from './AlertOctagon';
    export default AlertOctagon;
    